import { render, staticRenderFns } from "./prop-connector.vue?vue&type=template&id=50a7c1f4&"
import script from "./prop-connector.vue?vue&type=script&lang=ts&"
export * from "./prop-connector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports